import { Controller } from '@hotwired/stimulus';
import { ClearPaymentAccountsMixin } from '../../mixins/clear_payment_accounts_mixin';

export default class extends Controller {
  static values = {
    turboFrameTagName: String,
    selectSelector: String,
  };

  static targets = [
    'receiverNeedyIdInputWrapper',
    'receiverOrganizationIdInputWrapper',
  ];

  initialize() {
    ClearPaymentAccountsMixin(this);
  }

  clear_receiver({ params: { needyVisible, organizationVisible } }) {
    this.change_visibility(
      this.receiverNeedyIdInputWrapperTarget,
      needyVisible,
      this.receiverOrganizationIdInputWrapperTarget,
      organizationVisible,
    );

    this.receiverNeedyIdInputWrapperTarget.querySelector('input').value = null;
    this.receiverOrganizationIdInputWrapperTarget.querySelector('input').value =
      null;

    this.clear_receiver_results();
  }

  change_visibility(
    needyWrapper,
    needyVisible,
    organizationWrapper,
    organizationVisible,
  ) {
    if (needyVisible) {
      needyWrapper.classList.remove('hidden');
    } else {
      needyWrapper.classList.add('hidden');
    }

    if (organizationVisible) {
      organizationWrapper.classList.remove('hidden');
    } else {
      organizationWrapper.classList.add('hidden');
    }
  }

  clear_receiver_results() {
    this.clear_payment_accounts(
      this.selectSelectorValue,
      this.turboFrameTagNameValue,
    );
  }
}
